<script setup>
defineProps({ modelValue: { type: Object, required: true }, disabled: Boolean })
const emit = defineEmits(['update:modelValue'])
function update(value, key, event) { emit('update:modelValue', { ...value, [key]: event.target.value }) }
</script>
<template>
  <fieldset :disabled="disabled" class="receipt-fields">
    <legend>收货资料</legend>
    <label>收货人<input :value="modelValue.recipientName" required maxlength="100" autocomplete="shipping name" @input="update(modelValue, 'recipientName', $event)" /></label>
    <label>收货电话<input :value="modelValue.recipientPhone" required maxlength="30" type="tel" autocomplete="shipping tel" @input="update(modelValue, 'recipientPhone', $event)" /></label>
    <label>完整收货地址<textarea :value="modelValue.shippingAddress" required maxlength="500" autocomplete="shipping street-address" @input="update(modelValue, 'shippingAddress', $event)"></textarea></label>
  </fieldset>
</template>
